import jsonLogic from "json-logic-js";
import { find, get, } from "lodash";

/*
 * Create path of questions based on a graph (defining branches) and current answers.
 *
 * First each block is tested to see if it's visible or not. Then for each remaining blocks we perform a similar
 * test for each of its questions.
 *
 * The resulting path will contain questions which are allowed to be displayed.
 */
function createPath(blocks, questions, graph, context) {
    const path = graph
      .map(block => find(blocks, { name: block })) // Find block object for each block name
      // .map(block => { console.log(block.name); return block; })
      .filter(block => jsonLogic.apply(block.displayLogic, context)) // Filter out those who don't pass the test
      .map(block => block.questions) // For each block pass its array of questions
      .reduce((a, b) => a.concat(b), []) // Flatten array of arrays of questions
      // .map(q => { console.log(q); return q; })
      .map(q => find(questions, { name: q })) // Find question object for each question name
      // .map(q => { console.log(get(q, 'name')); return q; })
      .filter(q => jsonLogic.apply(q.displayLogic || true, context)) // Filter out those who don't pass the (existing) test
      .map(q => q.name); // Return list of question names
  
    return path;
}

export default createPath;
